var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1265_56471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1ZM23.9472 9.27639L26.9472 15.2764C27.0176 15.4172 27.0176 15.5828 26.9472 15.7236L25.9365 17.7422C25.9782 17.9885 26 18.2417 26 18.5C26 20.9853 23.9853 23 21.5 23C19.0147 23 17 20.9853 17 18.5C17 18.2452 17.0212 17.9954 17.0619 17.7521L17.1 17.8C16.6852 17.2469 16.3148 17 16 17C15.7138 17 15.3817 17.2041 15.012 17.6567L14.9383 17.7531C14.9789 17.996 15 18.2456 15 18.5C15 20.9853 12.9853 23 10.5 23C8.01472 23 6 20.9853 6 18.5C6 18.2417 6.02176 17.9885 6.06354 17.7422L5.05268 15.7236C4.99637 15.611 4.98511 15.4824 5.01889 15.3634L5.05268 15.2764L8.05268 9.27639C8.17617 9.0294 8.47651 8.92929 8.7235 9.05279C8.94304 9.16256 9.04654 9.41206 8.98009 9.63962L8.9471 9.72361L6.05989 15.5L6.514 16.4095C7.26685 14.977 8.76933 14 10.5 14C12.3211 14 13.8895 15.0818 14.5978 16.6378C15.0377 16.2197 15.5043 16 16 16C16.4957 16 16.9623 16.2197 17.404 16.6366C18.1105 15.0818 19.6789 14 21.5 14C23.2307 14 24.7332 14.977 25.486 16.4095L25.94 15.5L23.0528 9.72361C22.9293 9.47662 23.0294 9.17628 23.2764 9.05279C23.5234 8.92929 23.8237 9.0294 23.9472 9.27639ZM10.5 15C8.567 15 7 16.567 7 18.5C7 20.433 8.567 22 10.5 22C12.433 22 14 20.433 14 18.5C14 16.567 12.433 15 10.5 15ZM21.5 15C19.567 15 18 16.567 18 18.5C18 20.433 19.567 22 21.5 22C23.433 22 25 20.433 25 18.5C25 16.567 23.433 15 21.5 15Z",
    fill: "#007CB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1265_56471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.5a398e8094b10e605ffefc2acc462702.svg";
export { ForwardRef as ReactComponent };